/* @Created by FaisalK @Date  2018-09-25 @Desc YUP utilities*/
import * as toPath from "lodash.topath"
import * as cloneDeep from "lodash.clonedeep"
import * as tslib_1 from "tslib"
import { actions } from "react-redux-form";
import { notification } from "../../actions/uiAction";

/* @Created by FaisalK @Date  2018-09-25 @Desc check int of given number*/
const isInteger = (obj)=> {
	return String(Math.floor(Number(obj))) === obj;
};
/* @Created by FaisalK @Date  2018-09-25 @Desc getIn*/
const getIn=(obj, key, def, p) =>{
	if (p === void 0) { p = 0; }
	var path = toPath(key);
	while (obj && p < path.length) {
		obj = obj[path[p++]];
	}
	return obj === undefined ? def : obj;
}
/* @Created by FaisalK @Date  2018-09-25 @Desc setIn*/
const setIn=(obj, path, value)  =>{
	var res = {};
	var resVal = res;
	var i = 0;
	var pathArray = toPath(path);
	for (; i < pathArray.length - 1; i++) {
		var currentPath = pathArray[i];
		var currentObj = getIn(obj, pathArray.slice(0, i + 1));
		if (resVal[currentPath]) {
			resVal = resVal[currentPath];
		}
		else if (currentObj) {
			resVal = resVal[currentPath] = cloneDeep(currentObj);
		}
		else {
			var nextPath = pathArray[i + 1];
			resVal = resVal[currentPath] =
				isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
		}
	}
	if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
		return obj;
	}
	if (value === undefined) {
		delete resVal[pathArray[i]];
	}
	else {
		resVal[pathArray[i]] = value;
	}
	var result = tslib_1.__assign({}, obj, res);
	if (i === 0 && value === undefined) {
		delete result[pathArray[i]];
	}
	return result;
}

/* @Created by FaisalK @Date  2018-09-25 @Desc validate the value with YUP scheme*/
export const validate =  async (values,schema,levelDeep=0) => {
  try {
    await schema.validate(values, { abortEarly: false })
    return {}
  } catch (errorsList) {
		if(levelDeep){
			let errorsMsg = {};
			for (let _i = 0, _a = errorsList.inner; _i < _a.length; _i++) {
				let err = _a[_i];
				if (!errorsMsg[err.path]) {
					errorsMsg = setIn(errorsMsg, err.path, err.message);
				}
			}
			return errorsMsg;
		}
		return errorsList.inner.reduce((errorsList, err) => ({...errorsList,[err.path]: err.message}),{})
	}
}

/* @Created by FaisalK @Date  2018-09-25 @Desc checkErrors*/
export  function checkErrors(dispatch,formErrors,panel=false){
	let returnFlag=true;
	if(panel&&formErrors&&formErrors&&formErrors[panel]){
		let errorKeys=Object.keys(formErrors[panel]);
		dispatch(notification(formErrors[panel][errorKeys[0]]))
		returnFlag=false;
	}
	else if(!panel&&formErrors && Object.keys(formErrors).length){
		let errorKeys=Object.keys(formErrors);
		dispatch(notification(formErrors[errorKeys[0]]))
		returnFlag=false;
	}
	return returnFlag
}

/* @Created by FaisalK @Date  2018-09-25 @Desc validateData*/
export  function validateUpdateForm(form,schema,levelDeep=0) {
  return (dispatch) => {
    validate(form,schema,levelDeep).then(res=>{
      for(const key of Object.keys(res)) {
        dispatch(actions.setErrors("form."+key, res[key]));
      }
    })
  }
}
/* @Created by FaisalK @Date  2018-09-25 @Desc validateForm - deprecated*/
export async function validateAndCheckErrors(dispatch,formSchema,formValues,panel=false,levelDeep=0){
	return await new Promise((resolve, reject) => 
		validate(formValues,formSchema,levelDeep).then(formErrors=>{
			resolve(checkErrors(dispatch,formErrors,panel));
		})
	);
	
  }
  